import { render, staticRenderFns } from "./approveModal.vue?vue&type=template&id=97e79a6a&scoped=true&"
import script from "./approveModal.vue?vue&type=script&lang=js&"
export * from "./approveModal.vue?vue&type=script&lang=js&"
import style0 from "./approveModal.vue?vue&type=style&index=0&id=97e79a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e79a6a",
  null
  
)

export default component.exports